<div class="modal-backdrop" *ngIf="visible" (click)="reload()">
  <div class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog modal-lg modal-top">
    <div class="modal-content" (click)="$event.stopPropagation()">

        <!-- ===== HEADER ===== -->
        <div
          class="modal-header d-flex justify-content-end"
          style="border-bottom: 1px solid #DEDEDE;"
        >
          <button
            type="button"
            class="d-flex align-items-center justify-content-center"
            style="
              background-color: var(--theme-color);
              border: none;
              color: white;
              width: 32px;
              height: 32px;
              border-radius: 5px;
              font-size: 24px;
            "
            (click)="reload()" data-cta="cart.price_changed_reload" data-cta-loc="price_warning"
          >
            <i class="ri-close-line"></i>
          </button>
        </div>

        <!-- ===== BODY ===== -->
        <div class="modal-body text-center">
          <div class="mb-3">
            <img src="assets/images/svg/cart.svg" width="100" height="100"  loading="lazy" />
          </div>

          <h4 class="price-change-title mb-2">
            Thông tin giỏ hàng của Quý khách có sự thay đổi!
          </h4>

          <p style="font-size: 15px; color: #707070;">
            Vui lòng tải lại trang và kiểm tra thông tin trong giỏ trước khi đặt hàng
          </p>
        </div>

        <!-- ===== FOOTER ===== -->
        <div class="modal-footer d-flex justify-content-center">
          <button
            class="border-0"
            style="
              background-color: var(--theme-color-op-1);
              color: var(--theme-color);
              border-radius: 6px;
              padding: 8px 24px;
              font-size: 16px;
            "
            (click)="reload()" data-cta="cart.price_changed_reload" data-cta-loc="price_warning"
          >
            Tải lại trang
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
